import OLInteraction from './ol-interaction'
import OlInteraction from 'ol/interaction/Interaction'
import has from 'lodash/has'
import { Fill, Stroke, Style, Text } from 'ol/style'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { samplesLayerStyleFunction } from '../../LayersComponents/SamplesLayer'
import { throttle } from 'lodash'
import get from 'lodash/get'

const ANIMATION_DURATION = 20
const DEFAULT_SIZE = 26
const HOVER_SIZE = 30

const isFeatureSampleMarker = feature => has(feature.get('field'), 'externalId')

const createStyleWithSize = size =>
  new Style({
    text: new Text({
      text: '\uf3c5',
      textAlign: 'center',
      font: `900 ${size}px "Font Awesome 5 Free"`,
      textBaseline: 'bottom',
      fill: new Fill({ color: themeColors.mintColor }),
      stroke: new Stroke({ color: themeColors.black, width: 2 })
    })
  })

class SamplesHoverInteraction extends OLInteraction {
  constructor(props) {
    super(props)
    this.hoveredFeature = null
    this.animationFrame = null
  }

  createInteraction() {
    return new OlInteraction({
      handleEvent: throttle(this.handleEvent.bind(this), 100)
    })
  }

  handleEvent(event) {
    if (event.type !== 'pointermove') {
      return true
    }

    const pixel = event.map.getEventPixel(event.originalEvent)
    const feature = event.map.forEachFeatureAtPixel(pixel, f => (isFeatureSampleMarker(f) ? f : null))

    const selectedSampleId = get(this.props.selectedSample, 'id')
    if (feature && get(feature.get('field'), 'id') === selectedSampleId) {
      return this.updateHoverState(null)
    }

    this.updateHoverState(feature)
    return true
  }

  updateHoverState(feature) {
    // Handle feature change
    if (feature !== this.hoveredFeature) {
      // Animate out the previously hovered feature
      if (this.hoveredFeature) {
        this.animateSize(this.hoveredFeature, HOVER_SIZE, DEFAULT_SIZE)
      }

      // Animate in the new feature
      if (feature) {
        this.animateSize(feature, DEFAULT_SIZE, HOVER_SIZE)
      }

      this.hoveredFeature = feature
    }
  }

  animateSize(feature, startSize, endSize) {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }

    const startTime = Date.now()
    const isReturningToDefault = endSize === DEFAULT_SIZE

    const animate = () => {
      const elapsed = Date.now() - startTime
      const progress = Math.min(elapsed / ANIMATION_DURATION, 1)

      // Ease out quart function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      const currentSize = startSize + (endSize - startSize) * easeOutQuart

      feature.setStyle(createStyleWithSize(currentSize))

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(animate)
      } else if (isReturningToDefault) {
        // Restore original layer style when animation completes
        feature.setStyle(samplesLayerStyleFunction)
      }
    }

    animate()
  }

  componentWillUnmount() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
    super.componentWillUnmount()
  }
}

export default SamplesHoverInteraction
